import React, { useContext, useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import get from 'lodash/get';
import ImageComponent from 'atoms/Image';
import { ButtonType, ContainedButton } from 'atoms/Buttons';
import { ROUTE_URL, DISPOSITIONNEW, LOCAL_STORAGE_KEYS, DISPOSITION_KEYS } from 'common/constants/SharedConstants';
import { UserOrderContext } from 'context/context';
import { isEmptyObject, isMobileDeviceOnly, manipulateAlreadySearchedLocations } from 'common/utilities/utils';
import { getNearbyStores, AutoNearBystoreResponse, filterStatusResponse } from 'common/utilities/autoLocationUtils';
import { getUserLocationAccess, resetStores } from '@kfc-global/react-shared/redux/Actions/StoresAction';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import SEARCH_STORE_CONSTANTS from 'organisms/SearchStore/AU/Constants/SearchStoreConstants';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { localisationStartAnalytics } from 'common/utilities/analyticsUtils';
import { ChannelManager } from 'common/manager';
import { FORM } from 'organisms/SearchStore/AU/Config/searchStore.config';
import { AUTO_DETECT_CONSTANTS } from 'organisms/SearchStore/Constants/AutoDetectionConstants';
import { getCurrentLocationGlobal } from 'organisms/SearchStore/SearchStoreUtilities/AutoDetectionUtils';

export const SetLocationBanner = props => {
  const { setLocationdata = [] } = props;
  const { srcFile, locationMap, buttonText, textDescription } = setLocationdata;
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const [isMobile, setMobileHeader] = useState(isMobileDeviceOnly(window.innerWidth));
  const dispatch = useDispatch();
  const [activeDisposition, setActiveDisposition] = useState('');
  const [autoDetectFlow, setAutoDetectFlow] = useState(false);
  const [currentDispostion, setCurrentDisposition] = useState(false);
  const { AUTO_DETECTION_BUTTON_FLAG, PICK_UP, GRANTED } = AUTO_DETECT_CONSTANTS;
  const { profileReducer, tenantReducer, storesReducer, appStateReducer } = useSelector(data => data);
  const { allStores, storesWithStatus, storesSatusError, count, currentCount } = storesReducer;
  const { storeSearch = {}, tenantId } = tenantReducer;
  const enableAutoSetLocation = tenantReducer?.componentOptions?.web?.dispositionConfig?.enableAutoSetLocation;
  let userParams = appStateReducer.userStatus;
  const { maxDriveTimeMins, distanceMetrics, geohashprecision, boundingBoxSizeMeters, boundingBoxSizeDivider } =
    storeSearch;
  let dispositionNew = userOrderState?.dispositionNew;
  if (!dispositionNew) {
    const dispositionNewString = localStorage.getItem(DISPOSITIONNEW);
    dispositionNew = JSON.parse(dispositionNewString);
  }
  const allContentData = useSelector(data => {
    return {
      marketPageContent: get(data, 'marketConfigReducer.response', null),
    };
  });
  const autodetectDistance = allContentData?.marketPageContent?.headerData?.autodetectDistance;
  const SetLocationClickHandler = () => {
    dispatch(resetStores());
    localisationStartAnalytics();
    userOrderStateDispatch({ type: START_ORDER_CONSTANTS.SET_FIND_A_KFC_VIEW, value: { findAKFC: false } });
    userOrderStateDispatch({
      type: START_ORDER_CONSTANTS.SEARCH_ORDER_DATA,
      value: { showSearchStore: currentDispostion },
    });
    userOrderStateDispatch({ type: START_ORDER_CONSTANTS.DISPOSITION_DATA, value: { showDisposition: true } });
    userOrderStateDispatch({
      type: START_ORDER_CONSTANTS.DISPOSITION_METHOD,
      value: { dispositionType: DISPOSITION_KEYS.PICKUP },
    });
    userOrderStateDispatch({
      type: SEARCH_STORE_CONSTANTS.SET_LOCATION_BUTTON_FLAG,
      value: { setLocationClicked: true },
    });
    localStorage.setItem(LOCAL_STORAGE_KEYS.CONFIG_SEARCH_SCREEN, FORM);
  };
  useEffect(() => {
    window.addEventListener('resize', () => {
      const isMobileView = isMobileDeviceOnly(window.innerWidth);
      setMobileHeader(isMobileView);
    });
  }, [isMobile]);
  const checkAutoDetectionClicked = () => {
    dispatch(resetStores());
    localisationStartAnalytics();
    setCurrentDisposition(true);
    userOrderStateDispatch({ type: AUTO_DETECTION_BUTTON_FLAG, value: { autoDetectionClicked: true } });
    userOrderStateDispatch({ type: START_ORDER_CONSTANTS.DISPOSITION_DATA, value: { showDisposition: false } });
    localStorage.setItem(LOCAL_STORAGE_KEYS.CONFIG_SEARCH_SCREEN, FORM);
    setAutoDetectFlow(true);
    let getUserLocation = async () => {
      await getCurrentLocation();
    };
    window?.navigator?.geolocation?.getCurrentPosition(() => {
      dispatch(getUserLocationAccess(GRANTED));
      getUserLocation();
    });
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getCurrentLocation = useCallback(async () => {
    const results = await getCurrentLocationGlobal();
    if (results) {
      const { longitude = 0, latitude = 0 } = ChannelManager?.coordinates;
      getNearbyStores(latitude, longitude, boundingBoxSizeMeters, boundingBoxSizeDivider, geohashprecision, dispatch);
      manipulateAlreadySearchedLocations(ChannelManager?.address, SEARCH_STORE_CONSTANTS.ALREADY_SERACHED_LOCATIONS);
    }
  });

  useEffect(() => {
    if (autoDetectFlow && allStores?.length > 0 && count === currentCount) {
      const storeParam = {
        allStores,
        maxDistance: autodetectDistance,
        dispositionType: PICK_UP,
        setActiveDisposition,
        distanceMetrics,
        maxDriveTimeMins,
        dispatch,
        tenantId,
        SetLocationClickHandler,
      };
      AutoNearBystoreResponse(storeParam);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allStores, currentCount]);
  useEffect(() => {
    const storeObj = {
      storesWithStatus,
      dispositionNew,
      setAutoDetectFlow,
      activeDisposition,
      userOrderState,
      profileReducer,
      dispatch,
      tenantId,
      userOrderStateDispatch,
      userParams,
      tenantReducer,
      SetLocationClickHandler,
    };
    autoDetectFlow && storesWithStatus?.length > 0 && filterStatusResponse(storeObj);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storesWithStatus, storesSatusError]);

  return (
    <>
      {isEmptyObject(setLocationdata) && (
        <>
          <div
            id='kfc-banner-image'
            className={`setLocationData ${
              window.location.pathname === ROUTE_URL.NUTRITION_ALLERGEN ? 'for-nutrigen-banner' : ''
            }`}
            data-testid='banner-setLocation'
          >
            <ImageComponent data-testid='' srcFile={srcFile} alt={locationMap} className='google-location-img' />
            <div className='setLocationText'>{textDescription}</div>
            <ContainedButton
              variant={ButtonType.tertiary}
              className={'setLocation-button'}
              small={true}
              data-testid='set-location-button'
              onClickHandler={enableAutoSetLocation ? checkAutoDetectionClicked : SetLocationClickHandler}
            >
              {isMobile && window.location.pathname === ROUTE_URL.NUTRITION_ALLERGEN
                ? translateWithI18Next(TRANSLATE_MAPPING_KEY?.SET_YOUR_LOCATION)
                : buttonText}
            </ContainedButton>
            {isMobile && window.location.pathname === ROUTE_URL.NUTRITION_ALLERGEN ? (
              <span className='arrow_white'></span>
            ) : (
              ''
            )}
          </div>
          <hr role='presentation' className='setLocationdivider' />
        </>
      )}
    </>
  );
};
export default SetLocationBanner;
